// @flow
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Modal from 'modals/Modal';
import { humanDate } from 'utils/date';
import { hideModal as hideModalReduxAction } from '../redux/main/actions/modal';

const GradProgramContactSeeMoreInfoModal = ({
  hideModal,
  contact
}: {
  hideModal: typeof hideModalReduxAction,
  contact: {
    email: string,
    firstName: string,
    lastName: string,
    interestedInDegreeProgram?: string,
    expectedEnrollmentDate?: string,
    notes?: string,
    created: string
  }
}) => (
  <Modal
    title={
      /* TRANSLATORS: Grad Program admin modal that shows contact details */ getText(
        'More info'
      )
    }
    onClose={() => {
      hideModal();
    }}
    data-qa-id="grad-program-contact-see-more-info-modal"
  >
    <>
      <p>
        {getText('Email')}: {contact.email}
      </p>
      <p>
        {getText('First name')}: {contact.firstName}
      </p>
      <p>
        {getText('Last name')}: {contact.lastName}
      </p>
      {contact.interestedInDegreeProgram ? (
        <p>
          {getText('Interested in degree program')}:{' '}
          {contact.interestedInDegreeProgram}
        </p>
      ) : null}
      <p>
        {getText('Expected enrollment date')}: {contact.expectedEnrollmentDate}
      </p>
      <p>
        {getText('Notes')}: {contact.notes}
      </p>
      <p>
        {getText('Date Shared')}: {humanDate(contact.created)}
      </p>
    </>
  </Modal>
);

// export default GradProgramContactSeeMoreInfoModal;
export default withRouter(
  connect(
    null,
    {
      hideModal: hideModalReduxAction
    }
  )(GradProgramContactSeeMoreInfoModal)
);
